// Types
import {successGenerate} from '../common'
import * as Types from './types'
// Helpers

import { authInfoInitial } from "../../constants";
import { authProps } from "./auth.props";

const INIT_STATE: authProps = authInfoInitial;

const authReducer = (state = INIT_STATE, {type, payload}: any) => {
  switch (type) {
    case successGenerate(Types.LOGIN_REQUEST):
      return payload.data;
    case successGenerate(Types.LOG_OUT):
      localStorage.clear()
      window.location.href='/auth';
      return null

    default:
      return state
  }
}

export {authReducer}
